import { gql } from '@apollo/client';

// 내 장바구니 조회
export const GET_MY_CART = gql`
  query GetMyCart {
    myCart {
      id
      quantity
      createdAt
      updatedAt
      product {
        id
        name
        description
        specifications
        price
        discountPrice
        stock
        images
        isActive
        mainCategory {
          id
          name
        }
        subCategory {
          id
          name
        }
      }
      user {
        id
        name
        email
      }
    }
  }
`;

// 장바구니에 아이템 추가
export const ADD_TO_CART = gql`
  mutation AddToCart($productId: String!, $quantity: Int!) {
    addToCart(productId: $productId, quantity: $quantity) {
      id
      quantity
      createdAt
      product {
        id
        name
        description
        price
        discountPrice
        stock
        images
        isActive
        mainCategory {
          id
          name
        }
        subCategory {
          id
          name
        }
      }
    }
  }
`;

// 장바구니 아이템 수량 수정
export const UPDATE_CART_ITEM = gql`
  mutation UpdateCartItem($id: ID!, $quantity: Int!) {
    updateCartItem(id: $id, quantity: $quantity) {
      id
      quantity
      updatedAt
      product {
        id
        name
        description
        price
        discountPrice
        stock
        images
        isActive
        mainCategory {
          id
          name
        }
        subCategory {
          id
          name
        }
      }
    }
  }
`;

// 장바구니에서 아이템 제거
export const REMOVE_FROM_CART = gql`
  mutation RemoveFromCart($id: ID!) {
    removeFromCart(id: $id)
  }
`;

// 장바구니 전체 비우기
export const CLEAR_CART = gql`
  mutation ClearCart {
    clearCart
  }
`; 